const commonsStreamingLabels = [
  { label: 'config_manager.config_streaming.streaming_features_v2.billing' },
  {
    label:
      'config_manager.config_streaming.streaming_features_v2.protected_videos'
  },
  {
    label: 'config_manager.config_streaming.streaming_features_v2.club_caption'
  },
  {
    label: 'config_manager.config_streaming.streaming_features_v2.local_support'
  },
  {
    label:
      'config_manager.config_streaming.streaming_features_v2.ad_free_streaming'
  }
];

const configStreamingLabels = {
  defaultStreamingLabels: [...commonsStreamingLabels],
  streamingCampaignEligible: [...commonsStreamingLabels],
  streamingCampaignActivated: [...commonsStreamingLabels],
  sparkle: [
    {
      label: 'config_manager.config_streaming.sparkle_advantages.study_anywhere'
    },
    {
      label:
        'config_manager.config_streaming.sparkle_advantages.offline_courses'
    },
    {
      label:
        'config_manager.config_streaming.sparkle_advantages.create_communities'
    }
  ]
};

const streamingCondition = {
  DEFAULT: 'DEFAULT',
  STREAMING_CAMPAIGN_ELIGIBLE: 'STREAMING_CAMPAIGN_ELIGIBLE',
  STREAMING_CAMPAIGN_ACTIVATED: 'STREAMING_CAMPAIGN_ACTIVATED'
};

const labelsByStreamingCondition = {
  [streamingCondition.STREAMING_CAMPAIGN_ELIGIBLE]:
    configStreamingLabels.streamingCampaignEligible,
  [streamingCondition.STREAMING_CAMPAIGN_ACTIVATED]:
    configStreamingLabels.streamingCampaignActivated,
  [streamingCondition.DEFAULT]: configStreamingLabels.defaultStreamingLabels
};

const streamingCampaignLimitDate = '01/31/2021';

export {
  configStreamingLabels,
  streamingCondition,
  streamingCampaignLimitDate,
  labelsByStreamingCondition
};
